import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from "./common/Header";
import httpService from "../services/HttpService";
import "./BrandList.css";

function BrandList() {
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        httpService.get('/brands')
            .then(response => response.json())
            .then(data => {
                setBrands(data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Ошибка:", error);
                setError(error.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Загрузка...</div>;
    if (error) return <div>Ошибка: {error}</div>;

    const recommendedBrands = brands.filter(brand => brand.type === 'star');
    const allBrands = brands.filter(brand => brand.type !== 'star');

    return (
        <div>
            <Header/>
            <main className="bl-container">
                {recommendedBrands.length > 0 && (
                    <div>
                        <h2 className="bl-heading">Рекомендуемые бренды</h2>
                        {recommendedBrands.map(brand => (
                            <Link key={brand.id} to={`/brand/${brand.id}`} className="link brand-item">
                                <span>{brand.name}</span>
                                <span className="bl-forward-icon material-symbols-sharp">arrow_forward_ios</span>
                            </Link>
                        ))}
                    </div>
                )}
                <div className="bl-all-brands">
                    <h2 className="bl-heading">Все бренды</h2>
                    {allBrands.map(brand => (
                        <Link key={brand.id} to={`/brand/${brand.id}`} className="link brand-item">
                            <span>{brand.name}</span>
                            <span className="bl-forward-icon material-symbols-sharp">arrow_forward_ios</span>
                        </Link>
                    ))}
                </div>
            </main>
        </div>
    );
}

export default BrandList;